import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';

import { AlipayIcon } from './AlipayIcon';
import { AmericanExpressIcon } from './AmericanExpressIcon';
import { ApplePayIcon } from './ApplePayIcon';
import { BitcoinIcon } from './BitcoinIcon';
import { GiropayIcon } from './GiropayIcon';
import { GooglePayIcon } from './GooglePayIcon';
import { JCBIcon } from './JCBIcon';
import { MastercardIcon } from './MastercardIcon';
import { NetellerIcon } from './NetellerIcon';
import { PayPalIcon } from './PayPalIcon';
import { SkrillIcon } from './SkrillIcon';
import { WeChatIcon } from './WeChatIcon';

export const getIconPayments = (payment: string) => {
  switch (payment.toLowerCase().replaceAll(' ', '')) {
    case 'paypal':
      return <PayPalIcon />;
    case 'googlepay':
      return <GooglePayIcon />;
    case 'americanexpress':
      return <AmericanExpressIcon />;
    case 'mastercard':
      return <MastercardIcon />;
    case 'applepay':
      return <ApplePayIcon />;
    case 'jcb':
      return <JCBIcon />;
    case 'wechat':
      return <WeChatIcon />;
    case 'giropay':
      return <GiropayIcon />;
    case 'neteller':
      return <NetellerIcon />;
    case 'alipay':
      return <AlipayIcon />;
    case 'bitcoin':
      return <BitcoinIcon />;
    case 'skrill':
      return <SkrillIcon />;
    default:
      return <PanoramaFishEyeIcon />;
  }
};
